export function successStoriesSlider() {
    const sliderNavStories = $(".slider-nav-stories");
    const numberOfSlides = sliderNavStories.find('.slick-slide').length;

    sliderNavStories.slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false,
        variableWidth: true,
        infinite: true,
        mobileFirst: true,
        focusOnSelect: true,
        asNavFor: '.slider-for-stories',
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 7,
                    variableWidth: false,
                }
            },
        ]
    });

    $(".slider-for-stories").slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: true,
        infinite: true,
        arrows: false,
        fade: true,
        draggable: false,
        asNavFor: sliderNavStories,
    }).on('beforeChange', function () {
        $('.slider-for-stories .image-holder').each(function (i, el) {
            if ($(el).find('iframe').length) {
                $(el).find('iframe')[0].contentWindow.postMessage('{"event":"command", "method":"pause","func":"' + 'pauseVideo' + '","args":""}', '*');
            }
        });
    });


    $(window).on('resize', function () {
        let slidesShown = sliderNavStories.slick('slickGetOption', 'slidesToShow');

        if (numberOfSlides < slidesShown) {
            setTimeout(() => {
                sliderNavStories.find('.slick-track').css('transform', 'translate3d(0px, 0px, 0px)');
            }, 100);
        }
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/successStoriesSlider.js